import { render, staticRenderFns } from "./AwaitPart.vue?vue&type=template&id=5c0523ba&"
import script from "./AwaitPart.vue?vue&type=script&lang=js&"
export * from "./AwaitPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports